export const THIRTY_MB = 30 * 1024 * 1024

export const ALLOWED_FILE_TYPES = ['pdf', 'jpg', 'jpeg', 'png', 'svg']

export const DEEPEST_LAYER_TO_MOVE_CATEGORY = 5
export const DEEPEST_LAYER_TO_MOVE_FILE = 6
export const MAX_LAYER = 6
